import React, { Component } from "react";
import Ink from "react-ink";
import FeatherIcon from "feather-icons-react";
import { withRouter } from "react-router-dom";

class BackButtonHeader extends Component {
  static contextTypes = {
    router: () => null,
  };
  
  handleGoBack = () => {
    this.props.history.goBack();
  };

  render() {
    return (
      <React.Fragment>
        <div className='row'>
          <div className='col-2'>
            <button
              type='button'
              className='btn search-navs-btns back-button'
              style={{ position: "relative" }}
              onClick={this.handleGoBack}
              >
              <FeatherIcon icon='chevron-left' color='#000000' />
              <Ink duration='500' />
            </button>
          </div>
          <div
            className='col-10 text-center'
            style={{ display: "flex", alignItems: "center" }}>
            <div className='header-fixed-vendor'>
              <label className='text-dark '>{this.props.title}</label>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default withRouter(BackButtonHeader);
